import type { PostType, SoundType } from './sounds/types'

export type ListMediaType = 'sounds' | 'posts'

export interface AddToListRequest {
  itemIds: number[]
  listId: number
  mediaType: ListMediaType
}

export interface MoveItemsToOtherListOptions {
  fromListId: number
  itemsIds: {
    sounds: SoundType['id'][]
    posts: PostType['id'][]
  }
  toListId: number
}

export interface RemoveItemsFromListOptions {
  itemsIds: {
    soundIds: SoundType['id'][]
    postIds: PostType['id'][]
  }
  listId: number
}

interface ContentTypeTag {
  id: number
  value: string
}

export enum TagsTypes {
  Niche = 'NICHE',
  Hair_color = 'HAIR_COLOR',
  Ethnicity = 'ETHNICITY',
  Body_type = 'BODY_TYPE',
}

export interface ContentTypeTagsList {
  type: TagsTypes
  tags: ContentTypeTag[][]
  isMulti: boolean
}
